import classNames from "classnames";
import type { ComponentPropsWithoutRef } from "react";

import { anchorClassNames } from "@/react/helpers/cssAnchorHelpers";

import type { IconType } from "./IconNames";

export type { IconType };

export * from "./IconNames";

export interface IconProps extends ComponentPropsWithoutRef<"svg"> {
  size?: number;
  type: IconType;
  useWithFillCurrentColor?: boolean;
  useWithStrokeCurrentColor?: boolean;
  viewBox?: string;
}

interface SizeProps {
  height?: number;
  viewBox?: string;
  width?: number;
}

export const Icon = ({
  type,
  className = "",
  size,
  viewBox = "0 0 24 24",
  useWithFillCurrentColor = false,
  useWithStrokeCurrentColor = false,
  "aria-hidden": ariaHidden = true,
  ...props
}: IconProps) => {
  let sizeProps: SizeProps = { viewBox };

  if (size) {
    sizeProps = {
      width: size,
      height: size,
      viewBox: `0 0 ${size} ${size}`,
    };
  }

  return (
    <svg
      className={classNames(
        anchorClassNames(`icon icon-${type}`),
        {
          "animate-spin": type === "loader",
        },
        className,
      )}
      aria-hidden={ariaHidden}
      {...props}
      {...sizeProps}
    >
      <use
        xlinkHref={`#icon-${type}`}
        className={classNames(
          { "!fill-current": useWithFillCurrentColor },
          { "!stroke-current": useWithStrokeCurrentColor },
        )}
      />
    </svg>
  );
};
